// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SingleFieldLookupAddressForm-module-container-3mA-j{display:flex;flex-direction:column;gap:20px;gap:var(--spacing-sm, 20px)}.SingleFieldLookupAddressForm-module-postcodeInput-17xaL:-moz-read-only{pointer-events:none}.SingleFieldLookupAddressForm-module-postcodeInput-17xaL:read-only{pointer-events:none}", ""]);
// Exports
exports.locals = {
	"container": "SingleFieldLookupAddressForm-module-container-3mA-j",
	"postcodeInput": "SingleFieldLookupAddressForm-module-postcodeInput-17xaL"
};
module.exports = exports;
